import { DFSValueType, FormDefinition } from './form';
import { walkEval } from './FormVisitor';
import { BehaviorSubject, Observable } from 'rxjs';
import { ExpressionManager } from './ExpressionManager';

/**
 * Track visibility of any elements in evaluation definition that have conditional visibility.
 */
export class VisibilityManager {

  private registry: { [key: string]: Observable<DFSValueType> };
  private subject: BehaviorSubject<any>;

  constructor(form: FormDefinition, expressionManager: ExpressionManager) {

    this.subject = new BehaviorSubject(true);

    this.registry = {
      "/pages": this.subject
    };

    // todo just point to expressionmanager here. no need to duplicate registry. Subs are not shared so may not be a big deal.
    walkEval(form.render.editor, (r, s) => {

        var a = r.visibility ?? r.visible;

        const o = a !== undefined ? expressionManager.watch(a) : this.subject;

        if (!o) {
          throw new Error("No child visibility created for:'" + a);
        }

        this.registry[s] = o;
    })
}

  /**
   * Watch changes in a field's visibility
   */
  public watch = (r: string) => {
    return this.registry[r];
  };

  /**
   * Close registry
   * todo make sure subs are closed
   */
  public complete = () => {
    this.subject.complete();
    this.registry = {};
  }
}

// unused?
// function getParentPath(r) {
//     var i = r.lastIndexOf("/");
//     var t = r.substring(0, i);
//     if (r.substring(i + 1) !== "child") {
//         t = t.substring(0, t.lastIndexOf("/") || undefined)
//     }
//     return t
// }
